document.addEventListener('DOMContentLoaded', function () {
  setInterval(() => {
    const ele = document.querySelector('#rebuy-cart__progress-bar-meter-label');
    const element = document.querySelector('.rebuy-cart__flyout-subtotal-amount span:nth-of-type(2)');
    const element_two = document.querySelectorAll('.rebuy-money span');

    let content = ele.textContent;
    if (content.includes(".00")) {
      let newContent = content.replace(".00", "");
      content = newContent
      ele.textContent = content;
    }

    let contents = element.textContent;
    if (contents.includes(".00")) {
      let newElementContent = contents.replace(".00", "");
      contents = newElementContent
      element.textContent = contents;
    }

    element_two.forEach(item =>{
      if (item.textContent.includes(".00")) {
        let twoElement = item.textContent.replace(".00", "");
        item.textContent = twoElement
      }
    })
  }, 1000)
});